<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00080.installation.configurationPH' | translate"
      [description]="
        'P00080.installation.configurationPH.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00080.installation.alIConsigneAlarmBassePH.title' | translate"
      [titleListe]="
        'P00080.installation.alIConsigneAlarmBassePH.listTitle' | translate
      "
      [value]="actionStack!.getValue('alIConsigneAlarmBassePH')"
      [liste]="P00080ConsignPHBas()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Installation,
          'alIConsigneAlarmBassePH',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="
        'P00080.installation.alIConsigneAlarmHautePH.listTitle' | translate
      "
      [value]="actionStack!.getValue('alIConsigneAlarmHautePH')"
      [liste]="P00080ConsignPHHaut()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Installation,
          'alIConsigneAlarmHautePH',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
